
const messages = {
    en: {
        delivery: {
            states: {
                REVIEW: 'Review',
                NEW: 'New',
                PREPARING: 'Preparing',
                READY: 'ready',
                ON_THE_WAY: 'On the way',
                DELIVERED: 'Delivered',
                PENDING_RECEIPT: 'Pending receipt',
                CANCELED: 'Canceled',
                SCHEDULED: 'Scheduled',
                WAITING:'Waiting',
                SERVED: 'Served',
            },
            statesDescription: {
                REVIEW: 'Su orden esta siendo revisada y pronto sera confirmada',
                NEW: 'Su orden ha sido confirmada y pronto se estará preparando',
                PREPARING: 'Su orden se esta preparando',
                READY: 'Tu pedido esta listo y a pocos minutos de ser entregado por uno de nuestros repartidores',
                ON_THE_WAY: 'Su orden esta en camino',
                DELIVERED: 'Ya recibiste tu pedido, a disfrutar!!',
                PENDING_RECEIPT: 'Su orden requiere adjuntar comprobante',
                SCHEDULED: 'Su pedido esta programado',
                WAITING:'Waiting',
                SERVED: 'Served',
            },
        }
    },
    es: {
        delivery: {
            states: {
                REVIEW: 'Revision',
                NEW: 'Ingresada',
                PREPARING: 'Preparando',
                READY: 'Listo',
                ON_THE_WAY: 'En camino',
                DELIVERED: 'Entregado',
                PENDING_RECEIPT: 'Comprobante pendiente',
                CANCELED: 'Cancelado',
                SCHEDULED: 'Programado',
                WAITING:'Esperando',
                SERVED: 'Servido',
            },
            statesDescription: {
                REVIEW: 'Su orden esta siendo revisada y pronto sera confirmada',
                NEW: 'Su orden ha sido confirmada y pronto se estará preparando',
                PREPARING: 'Su orden se esta preparando',
                READY: 'Tu pedido esta listo y a pocos minutos de ser entregado por uno de nuestros repartidores',
                ON_THE_WAY: 'Su orden esta en camino',
                DELIVERED: 'Ya recibiste tu pedido, a disfrutar!!',
                PENDING_RECEIPT: 'Su orden requiere adjuntar comprobante',
                SCHEDULED: 'Su pedido esta programado',
                WAITING:'Su pedido espera ser servido',
                SERVED: 'Su pedido fue servido',
            },
        }
    },
    pt: {
        delivery: {
            states: {
                REVIEW: 'Revision',
                NEW: 'Nuevo',
                PREPARING: 'Preparando',
                READY: 'Listo',
                ON_THE_WAY: 'En camino',
                DELIVERED: 'Entregado',
                PENDING_RECEIPT: 'Pending receipt',
                CANCELED: 'Canceled',
                SCHEDULED: 'Programado',
                WAITING:'Waiting',
                SERVED: 'Served',
            },
            statesDescription: {
                REVIEW: 'Su orden esta siendo revisada y pronto sera confirmada',
                NEW: 'Su orden ha sido confirmada y pronto se estará preparando',
                PREPARING: 'Su orden se esta preparando',
                READY: 'Tu pedido esta listo y a pocos minutos de ser entregado por uno de nuestros repartidores',
                ON_THE_WAY: 'Su orden esta en camino',
                DELIVERED: 'Ya recibiste tu pedido, a disfrutar!!',
                PENDING_RECEIPT: 'Su orden requiere adjuntar comprobante',
                SCHEDULED: 'Su pedido esta programado',
                WAITING:'Waiting',
                SERVED: 'Served',
            },
        }
    }

}


export default messages
